import { PeriodEnum, SeasonEnum } from '../enums';

export class DateUtils {

  public static getSeason(date: Date): SeasonEnum {
    const dateMonthDayFormat = (date.getMonth() + 1) * 100 + date.getDate();
    if (dateMonthDayFormat >= 320 && dateMonthDayFormat < 620) {
      return SeasonEnum.SPRING;
    } else if (dateMonthDayFormat >= 620 && dateMonthDayFormat < 920) {
      return SeasonEnum.SUMMER;
    } else if (dateMonthDayFormat >= 920 && dateMonthDayFormat < 1220) {
      return SeasonEnum.FALL;
    }
    return SeasonEnum.WINTER;
  }

  public static isSamePeriod(period: PeriodEnum, date1: Date, date2: Date): boolean {
    return {
      [PeriodEnum.DAY]: () => {
        return (
          (date1.getUTCDate() === date2.getUTCDate()) &&
          (date1.getUTCMonth() === date2.getUTCMonth()) &&
          (date1.getUTCFullYear() === date2.getUTCFullYear())
        );
      }
    }[period]();
  }

}
